<template>
  <div class='menu'>
    <el-tree
      :data="functionData"
      :props="defaultProps"
      accordion
      node-key="moduleid"
      ref="dataConfigTree"
      :highlight-current="true"
      class="tree"
      @node-click="handleNodeClick"
    >
    </el-tree>
  </div>
</template>
<script>
import Api from '../../api/index'


export default {
  data () {
    return {
      functionData: [],
      defaultProps: {
        children: '123',
        label: 'modulename',
        disabled: 'isenable'
      }
    }
  },

  created () {
    this.GetDataTreeList();

  },
  mounted () {

  },
  methods: {
    async GetDataTreeList () {
      const res = await Api.sysFunction.GetDataTreeList()
      if (!res.success) return
      this.functionData = res.rows
      this.$store.state.sysTreeList = res.rows

    },
    async handleNodeClick (data) {
      const res = await Api.sysFunction.GetDataByParentId(data.moduleid)
      if (res.success != true) return this.$Message.info(res.msg)
      this.$emit('tableData', res.rows)

      this.$refs.dataConfigTree.setCurrentKey(data.itemid)
    }

  }

}
</script>
<style lang='less' scoped>
ul {
  li {
    padding: 10px 20px;
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  li > a:hover {
    background-color: #87cefa;
    color: #fff !important;
  }
}
.current {
  color: #fff !important;
  font-weight: bold !important;
  background-color: #87cefa;
}
.origin {
  color: #000;
  font-weight: normal;
}
/deep/.tree > .el-tree-node > .el-tree-node__content {
  height: 40px;
  line-height: 40px;
}
/deep/.tree > .el-tree-node > .el-tree-node__children > .el-tree-node {
  height: 40px;
  line-height: 40px;
}
/deep/.el-tree-node__content {
  &:hover {
    background: #d5e8fc;
  }
}
/deep/.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #3498db !important;
  color: #fff;
}
</style>